/**
 * お知らせ一覧取得API
 */
import { Component, Vue } from 'vue-property-decorator'
import {
  ApiResponseNotificationList,
  ApiResponseNotificationEditData,
  ApiResponseNotificationBoard,
} from '@/models/apiResponses/notifications'
import { NotificationSearchParamsType, NotificationEditType } from '@/models/notificationModel'

@Component
export default class NotificationsApi extends Vue {
  /**
   * 生徒画面・お知らせ掲示一覧取得
   * @returns お知らせ掲示一覧
   */
  protected async getApiResponseNotificationBoard(): Promise<ApiResponseNotificationBoard[]> {
    const { data }: { data: ApiResponseNotificationBoard[] } =
      await Vue.prototype.$http.httpWithToken.get(`v2/student/notifications/board`)

    return data
  }

  /**
   * お知らせ管理一覧検索
   * @param params 検索パラメーター群
   * @returns ページネーション情報付きお知らせ一覧情報
   */
  protected async searchNotification(params: NotificationSearchParamsType): Promise<ApiResponseNotificationList> {
    const { data }: { data: ApiResponseNotificationList } = await Vue.prototype.$http.httpWithToken
      .get(`/v2/admin/notifications/search`, { params: params })
      .catch(() => ({ data: { responses: [], pagination: null } }))

    return data
  }

  /**
   * お知らせ情報取得
   * @param id お知らせID
   * @returns お知らせ情報
   */
  protected async getNotificationData(id: number): Promise<ApiResponseNotificationEditData> {
    const { data }: { data: ApiResponseNotificationEditData } = await Vue.prototype.$http.httpWithToken.get(
      `/v2/admin/notifications/${id}`
    )

    return data
  }

  /**
   * お知らせ情報登録
   * @param editData お知らせ編集情報
   */
  protected async createNotificationData(editData: NotificationEditType): Promise<void> {
    // 本文のbase64エンコードに成功した場合はその値をパラメーターに設定
    const base64Message = await Vue.prototype.$compress.stringToBase64(editData.message)
    await Vue.prototype.$http.httpWithToken.post(`/v2/admin/notifications`, {
      title: editData.title,
      startDate: editData.startDate,
      endDate: editData.endDate,
      message: base64Message !== null ? base64Message : editData.message,
    })
  }

  /**
   * お知らせ情報更新
   * @param editData お知らせ編集情報
   */
  protected async updateNotificationData(editData: NotificationEditType): Promise<void> {
    // 本文のbase64エンコードに成功した場合はその値をパラメーターに設定
    const base64Message = await Vue.prototype.$compress.stringToBase64(editData.message)
    await Vue.prototype.$http.httpWithToken.put(`/v2/admin/notifications/${editData.id}`, {
      title: editData.title,
      startDate: editData.startDate,
      endDate: editData.endDate,
      message: base64Message !== null ? base64Message : editData.message,
    })
  }

  /**
   * お知らせ情報削除
   * @param id お知らせID
   */
  protected async deleteNotificationData(id: number): Promise<void> {
    await Vue.prototype.$http.httpWithToken.delete(`/v2/admin/notifications/${id}`)
  }
}
